module.exports = __webpack_public_path__ + "img/changeFineness-2@2x.4fce2c1.webp";